export default __webpack_public_path__ + "static/media/cpv_31_electrical-machines.e03036d5.svg";